module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Assens_(Vaud)-e95a8631641691e52f78fe55a7d71829.svg";